export const removeEmptyFields = (data: any) => {
  const newData = { ...data };
  for (const key in newData) {
    if (newData[key] === '' || newData[key] === null || newData[key] === undefined) {
      delete newData[key];
    }
  }
  return newData;
};
